export const GET_NETWORK_REQUEST = 'GET_NETWORK_REQUEST';
export const GET_NETWORK_SUCCESS = 'GET_NETWORK_SUCCESS';
export const GET_NETWORK_FAILURE = 'GET_NETWORK_FAILURE';